import Dispatcher from '../shared/Dispatcher'

const dispatcher = new Dispatcher()
window.xDispatcher = dispatcher
